import { StrictMode } from "react"
import * as ReactDOM from "react-dom/client"

import "@mantine/core/styles.css"

import { MantineProvider } from "@mantine/core"

import { App } from "./App"
import { theme } from "./theme"

const element = document.getElementById("root")
if (element)
    ReactDOM.createRoot(element).render(
        <StrictMode>
            <MantineProvider theme={theme}>
                <App />
            </MantineProvider>
        </StrictMode>,
    )
